import React from 'react';
import { useTranslation } from "react-i18next";

function AltynEmelSightPage(props) 
{
    const { t } = useTranslation();

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom">
            <h1 className="uk-heading-medium uk-margin-bottom">
                {t("altynemel.title", "Altyn-Emel National Park")}
            </h1>

            <p className="uk-text-lead uk-margin-bottom">
                {t(
                    "altynemel.intro",
                    "Altyn-Emel National Park, located in the Almaty Region of Kazakhstan, is one of the country’s largest protected areas. It is renowned for its Singing Dune, diverse wildlife, and dramatic desert and mountain landscapes."
                )}
            </p>

            <h2 className="uk-heading-line uk-text-bold">
                <span>{t("altynemel.highlightsTitle", "Highlights")}</span>
            </h2>
            <ul className="uk-list uk-list-bullet uk-margin-bottom">
                <li>{t("altynemel.highlight1", "The Singing Dune, a massive sand dune that produces a resonant humming sound when the sand moves.")}</li>
                <li>{t("altynemel.highlight2", "Unique geological formations, including colorful Aktau and Katutau mountains.")}</li>
                <li>{t("altynemel.highlight3", "Rich biodiversity, home to rare species such as kulan (wild ass), gazelles, and argali.")}</li>
                <li>{t("altynemel.highlight4", "Cultural heritage sites, including ancient petroglyphs and burial mounds.")}</li>
            </ul>

            <p className="uk-text uk-text-justify">
                {t(
                    "altynemel.conclusion",
                    "Altyn-Emel combines natural wonders, unique landscapes, and cultural history, making it an essential destination for those exploring Kazakhstan’s protected areas."
                )}
            </p>
        </div>
    );
}

export default AltynEmelSightPage;
